import { z } from 'zod';

export const deleteUntimedClipsResponseSchema = z.object({
  deleted: z.number(),
});

export type IDeleteUntimedClipsResponse = z.infer<typeof deleteUntimedClipsResponseSchema>;
